module.exports = __webpack_public_path__ + "static/media/icon-line-sport.7f42a7ee.svg";